import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-datepicker/dist/react-datepicker.css";
import reportWebVitals from "./reportWebVitals";
import { RegisterIdProvider } from "./hooks/RegisterIdContext";
import { ConfigProvider } from "antd";
import { green } from "@ant-design/colors";
import { ToastContainer } from "react-toastify";// Ant Design colors
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConopsContextProvider } from "../src/CONOPS/conops-hooks/ConopsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
const GOOGLE_CLIENT_ID =
  "956432621786-6ikqpn5blsri8ppdhifbb50kpu3fbrlf.apps.googleusercontent.com";
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: green[4], // Sets primary color to #1677FF
      },
    }}
  >
    <ConopsContextProvider>
      <RegisterIdProvider>
        <ToastContainer />
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>

          <App />
        </GoogleOAuthProvider>
      </RegisterIdProvider>
    </ConopsContextProvider>
  </ConfigProvider>
);

// Performance monitoring
reportWebVitals();
